import * as React from "react";
import { CircleHelp } from "lucide-react";
import { cn } from "../lib/cn";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";

/**
 * "?" que abre uma explicação curta de como a tela funciona. Usado pelo título dos diálogos (prop
 * `ajuda` de `DialogTitle`/`SheetTitle`) e por cabeçalhos próprios. Popover e não tooltip: precisa
 * funcionar no toque e o texto tem mais de uma linha.
 */
export function AjudaPopover({
  children,
  rotulo = "Como funciona",
  className,
}: {
  children: React.ReactNode;
  rotulo?: string;
  className?: string;
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={rotulo}
          title={rotulo}
          className={cn(
            "inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-zinc-400 transition-colors hover:bg-zinc-100 hover:text-zinc-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring dark:hover:bg-muted dark:hover:text-foreground",
            className,
          )}
        >
          <CircleHelp className="h-4 w-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="w-80 max-w-[calc(100vw-2rem)] border border-zinc-200 bg-white p-4 text-[13px] leading-relaxed text-zinc-700 shadow-lg dark:border-border dark:bg-card dark:text-foreground"
      >
        {children}
      </PopoverContent>
    </Popover>
  );
}

/** Título + "?" lado a lado. O botão fica fora do `h2`: senão o texto dele entraria no nome
 *  acessível do diálogo. */
export function TituloComAjuda({
  ajuda,
  classeDoGrupo,
  children,
}: {
  ajuda: React.ReactNode;
  classeDoGrupo?: string;
  children: React.ReactNode;
}) {
  return (
    <div className={cn("flex min-w-0 items-center gap-1", classeDoGrupo)}>
      {children}
      <AjudaPopover>{ajuda}</AjudaPopover>
    </div>
  );
}
